import { render } from "./TheCommissions.vue?vue&type=template&id=3d99babf&ts=true"
import script from "./TheCommissions.vue?vue&type=script&lang=ts"
export * from "./TheCommissions.vue?vue&type=script&lang=ts"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__